import {
  TRAVEL_PREMIUMS,
  TRAVEL_PREMIUMS_SUCCESS,
  TRAVEL_PREMIUMS_ERROR,
  TRAVEL_PREMIUMS_CLEAR_DATA,
} from "./actionTypes";

const initialState = {
  responseTravelPremiums: null,
  errorTravelPremiums: null,
  loadingTravelPremiums: false,
};

const travelPremiumsReducer = (state = initialState, action) => {
  switch (action.type) {
    case TRAVEL_PREMIUMS:
      return {
        ...state,
        loadingTravelPremiums: true,
        errorTravelPremiums: null,
      };
    case TRAVEL_PREMIUMS_SUCCESS:
      return {
        ...state,
        responseTravelPremiums: action.payload,
        loadingTravelPremiums: false,
        errorTravelPremiums: null,
      };
    case TRAVEL_PREMIUMS_ERROR:
      return {
        ...state,
        responseTravelPremiums: null,
        errorTravelPremiums: action.payload,
        loadingTravelPremiums: false,
      };
    case TRAVEL_PREMIUMS_CLEAR_DATA:
      return {
        ...state,
        responseTravelPremiums: null,
        errorTravelPremiums: null,
        loadingTravelPremiums: false,
      };
    default:
      return state;
  }
};

export default travelPremiumsReducer;
